export type Provedor = 'youtube' | 'vimeo' | 'panda' | 'bunny';
export const PROVEDORES: Provedor[] = ['youtube', 'vimeo', 'panda', 'bunny'];
export type StatusCurso = 'rascunho' | 'publicado';
export type StatusMatricula = 'em_andamento' | 'concluido';

export interface CursoResumo {
  id: string;
  titulo: string;
  descricao: string | null;
  categoria: string | null;
  status: StatusCurso;
  prerequisito_curso_id: string | null;
  prerequisito: string | null;
  modulos: number;
  aulas: number;
  carga_minutos: number;
  matriculados: number;
  concluidos: number;
}

export interface AulaFicha {
  id: string;
  modulo_id: string;
  titulo: string;
  descricao: string | null;
  ordem: number;
  provedor: Provedor | null;
  video_id: string | null;
  duracao_minutos: number;
  prerequisito_aula_id: string | null;
  materiais: number;
}

export interface FichaCurso extends Omit<CursoResumo, 'modulos'> {
  config: { panda_zona?: string | null; bunny_biblioteca?: string | null };
  modulos: { id: string; titulo: string; ordem: number; aulas: AulaFicha[] }[];
}

export interface AulaAssistir {
  id: string;
  titulo: string;
  descricao: string | null;
  duracao_minutos: number;
  provedor: Provedor | null;
  concluida: boolean;
  bloqueada: boolean;
  motivo: 'sem_matricula' | 'curso_prerequisito' | 'aula_prerequisito' | null;
  prerequisito: string | null;
  embed: string | null;
  materiais: { id: string; nome: string; mime: string; tamanho: number }[];
}

export interface Assistir {
  curso: { id: string; titulo: string; descricao: string | null; status: StatusCurso; carga_minutos: number };
  prerequisito: { id: string; titulo: string | null; concluido: boolean } | null;
  matricula: { id: string; percentual: number; status: StatusMatricula; concluido_em: string | null; certificado: string | null } | null;
  previa: boolean;
  modulos: { id: string; titulo: string; aulas: AulaAssistir[] }[];
}

export interface MeuCurso {
  matricula_id: string;
  curso_id: string;
  titulo: string;
  categoria: string | null;
  percentual: number;
  status: StatusMatricula;
  origem: 'manual' | 'trilha';
  aulas: number;
  carga_minutos: number;
  concluido_em: string | null;
  certificado: string | null;
}

export interface TrilhaLinha {
  id: string;
  nome: string;
  descricao: string | null;
  funcao_id: string;
  funcao: string | null;
  cursos: { id: string; titulo: string; status: StatusCurso }[];
  matriculas: number;
}

export interface LinhaProgresso {
  id: string;
  funcionario_id: string;
  funcionario: string | null;
  curso_id: string;
  curso: string;
  percentual: number;
  status: StatusMatricula;
  origem: 'manual' | 'trilha';
  trilha: string | null;
  concluido_em: string | null;
  certificado: string | null;
  created_at: string;
}

export interface Certificado {
  codigo: string;
  funcionario_nome: string;
  curso_titulo: string;
  carga_minutos: number;
  emitido_em: string;
  organizacao: string | null;
  valido: boolean;
}

export const SELECT = 'h-10 rounded-lg border border-borda bg-sup-1 px-2 text-sm text-tinta-1 outline-none focus:border-acento';
export const BOTAO_PRIMARIO = 'h-10 rounded-lg bg-acento px-4 text-sm font-medium text-acento-tinta hover:bg-acento-forte disabled:opacity-50';

export const COR_STATUS: Record<StatusCurso | StatusMatricula, string> = {
  rascunho: 'bg-sup-3 text-tinta-2',
  publicado: 'bg-sucesso/15 text-sucesso',
  em_andamento: 'bg-azul/15 text-azul',
  concluido: 'bg-sucesso/15 text-sucesso',
};

export const formatarData = (iso: string | null, idioma: string): string => (iso ? new Intl.DateTimeFormat(idioma, { dateStyle: 'short' }).format(new Date(iso)) : '');
export const formatarDataLonga = (iso: string, idioma: string): string => new Intl.DateTimeFormat(idioma, { dateStyle: 'long' }).format(new Date(iso));
